import { RouteConfig } from 'vue-router';

export default <Array<RouteConfig>> [
	{
		name: "uiLibDatePicker",
		path: "datepicker",
		component: () => import('../../views/UILib/IBUIDatepicker.vue')
	},
	{
		name: 'uiLibDialog',
		path: 'dialog',
		component: () => import('../../views/UILib/IBUIDialog.vue')
	},
	{
		name: 'uiLibNewEImzo',
		path: 'new-eimzo-dialog',
		component: () => import('../../views/UILib/IBUICrkDialog.vue')
	},
	{
		name: 'uiLib3DSelect',
		path: 'scroll-picker',
		component: () => import('../../views/UILib/IBUIScrollPicker.vue')
	},
	{
		name: 'uiLib3DSelectWithout3d',
		path: 'scroll-picker-without-3d',
		component: () => import('../../views/UILib/IBUIScrollPickerWithout3D.vue')
	}
]